export const Questionnaire = {
  WHO_IS_LOOKING_FOR_COACHING: {
    question: 'Who is looking for coaching?',
    stepNumber: 1,
  },
  CONTACT_DETAILS: {
    question: 'What are your contact details?',
    stepNumber: 2,
  },
  CHILD_FIRST_NAME: {
    question: 'What is your child first name?',
    stepNumber: 2,
  },
  CHILD_LAST_NAME: {
    question: 'What is your child last name?',
    stepNumber: 2,
  },
  AVAILABILITY: {
    question: 'What is your availability?',
    stepNumber: 3,
  },
  REASON: {
    question: 'What is your reason for wanting golf lessons?',
    stepNumber: 4,
  },
  EXPERIENCE: {
    question: 'Have you ever taken a lesson before?',
    stepNumber: 5,
  },
  SHOOT: {
    question: 'What do you normally shoot?',
    stepNumber: 6,
  },
  TIME_TO_IMPROVE: {
    question: 'How soon are you looking to improve?',
    stepNumber: 7,
  },
}
